/**
 * Helpers for GET /api/v1/media/stats?clientIds=…&clientIds=…
 * Response: array of rows with clientId, mediaTypeId, totalCount, totalFilesize, etc.
 */

export function normalizeMediaStatsRows(raw) {
  if (raw == null) return []
  if (Array.isArray(raw)) return raw
  if (Array.isArray(raw.data)) return raw.data
  if (Array.isArray(raw.results)) return raw.results
  if (Array.isArray(raw.content)) return raw.content
  return []
}

/** @param {(string|number)[]} clientIds */
export function buildMediaStatsQueryString(clientIds) {
  const ids = (clientIds || [])
    .map((id) => String(id).trim())
    .filter((s) => s && s !== "undefined" && s !== "null")
  if (ids.length === 0) return ""
  const q = new URLSearchParams()
  for (const id of ids) {
    q.append("clientIds", id)
  }
  return `?${q.toString()}`
}

export function groupMediaStatsRowsByClient(rows) {
  const byClient = {}
  for (const row of rows || []) {
    if (row?.clientId == null) continue
    const key = String(row.clientId)
    if (!byClient[key]) byClient[key] = []
    byClient[key].push(row)
  }
  return byClient
}

export function filterMediaStatsRowsForClient(rows, clientId) {
  if (clientId == null || clientId === "") {
    return Array.isArray(rows) ? rows : []
  }
  const key = String(clientId)
  return (rows || []).filter((r) => String(r.clientId) === key)
}

const EMPTY_MEDIA_STATS = []

/** Read normalized stats rows for one client from Redux `mediaStats.statsByClient`. */
export function getMediaStatsListForClient(statsByClient, clientId) {
  if (clientId == null || clientId === "") return EMPTY_MEDIA_STATS
  const map = statsByClient || {}
  const key = String(clientId)
  const v = map[key] ?? map[clientId]
  return Array.isArray(v) ? v : EMPTY_MEDIA_STATS
}

export function clientHasUploadedMedia(statsByClient, clientId) {
  const rows = getMediaStatsListForClient(statsByClient, clientId)
  return rows.some((item) => Number(item.totalCount) > 0)
}
